import { useEffect, useState } from "react";

const OC_THEME_KEY = "oc_theme";

export function useOcTheme() {
  const [isDark, setIsDark] = useState(() => {
    return localStorage.getItem(OC_THEME_KEY) === "dark";
  });

  useEffect(() => {
    const root = document.documentElement;
    if (isDark) {
      root.classList.add("dark");
    } else {
      root.classList.remove("dark");
    }
    localStorage.setItem(OC_THEME_KEY, isDark ? "dark" : "light");
  }, [isDark]);

  return { isDark, toggleTheme: () => setIsDark((d) => !d) };
}
